import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled, { css } from 'styled-components';
import { getPublicGameVariantLink, routes } from '../../data/routes';
import { gameStore } from '../../stores/GameStore';
import { Heading1Base } from '../shared/Heading';
import { ModulesToPlayListView } from '../workshopmanagement/ModuleToPlayListView';
const Heading = styled(Heading1Base).withConfig({
  displayName: "PublicMenuModuleSelection__Heading",
  componentId: "sc-1ofy3ci-0"
})(["margin-top:1em;margin-bottom:0.5em;"]);
const TopAreaLink = styled.a.withConfig({
  displayName: "PublicMenuModuleSelection__TopAreaLink",
  componentId: "sc-1ofy3ci-1"
})(["display:block;margin-bottom:1.2em;"]);
const Container = styled.div.withConfig({
  displayName: "PublicMenuModuleSelection__Container",
  componentId: "sc-1ofy3ci-2"
})(["display:flex;"]);
const Area = styled.div.withConfig({
  displayName: "PublicMenuModuleSelection__Area",
  componentId: "sc-1ofy3ci-3"
})(["flex:1;"]);
const Divider = styled.div.withConfig({
  displayName: "PublicMenuModuleSelection__Divider",
  componentId: "sc-1ofy3ci-4"
})(["margin:0 2em;"]);
const AreaHeading = styled(Heading1Base).withConfig({
  displayName: "PublicMenuModuleSelection__AreaHeading",
  componentId: "sc-1ofy3ci-5"
})(["margin-top:1em;margin-bottom:0.7em;white-space:nowrap;"]);
const StandaloneModulesList = styled.div.withConfig({
  displayName: "PublicMenuModuleSelection__StandaloneModulesList",
  componentId: "sc-1ofy3ci-6"
})(["max-height:300px;overflow-y:auto;ul{margin-top:0.2em;li{margin-bottom:0.2em;}}"]);
const LeftAreaLink = styled.a.withConfig({
  displayName: "PublicMenuModuleSelection__LeftAreaLink",
  componentId: "sc-1ofy3ci-7"
})(["margin-top:10px;margin-bottom:10px;display:block;", ""], props => props.disabled && css(["pointer-events:none;cursor:default;color:grey;"]));
export const PublicMenuModuleSelection = ({
  modules
}) => {
  const {
    t
  } = useTranslation();
  const [modulesToPlay, setModulesToPlay] = useState([]);
  const sortedModules = modules.sort((a, b) => a.name.localeCompare(b.name, gameStore.languageKey));
  const addOnModules = sortedModules.filter(module => module.mayBePlayedInWorkshops);
  const standaloneModules = sortedModules.filter(module => !module.mayBePlayedInWorkshops);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Heading, null, t("editor.menu_main_game")), /*#__PURE__*/React.createElement(TopAreaLink, {
    href: routes.mainGame
  }, t("editor.menu_main_game_play")), /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Area, null, /*#__PURE__*/React.createElement(AreaHeading, null, t("editor.menu_modules")), /*#__PURE__*/React.createElement(ModulesToPlayListView, {
    playableModules: addOnModules,
    modulesToPlay: modulesToPlay,
    addModuleToPlay: id => setModulesToPlay([...modulesToPlay, id]),
    removeModuleToPlay: id => setModulesToPlay(modulesToPlay.filter(existingId => existingId != id)),
    showFilter: false
  }), /*#__PURE__*/React.createElement(LeftAreaLink, {
    href: getPublicGameVariantLink(modulesToPlay),
    disabled: modulesToPlay.length === 0
  }, t("editor.menu_modules_play"))), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Area, null, /*#__PURE__*/React.createElement(AreaHeading, null, t("editor.menu_standalone_modules")), /*#__PURE__*/React.createElement("div", null, t("editor.menu_standalone_modules_play")), /*#__PURE__*/React.createElement(StandaloneModulesList, null, /*#__PURE__*/React.createElement("ul", null, standaloneModules.map(module => /*#__PURE__*/React.createElement("li", {
    key: module.$modelId
  }, /*#__PURE__*/React.createElement("a", {
    href: getPublicGameVariantLink([module.$modelId])
  }, module.name))))))));
};